import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute, Params }   from '@angular/router';
import * as moment from 'moment/moment';
import { OrderService } from '../order.service';
import {IMyOptions, IMyDateModel} from 'ngx-mydatepicker';
import { AuthenticationService } from '../../security/authentication.service';
import { LocalStorageService} from '../../shared/local-storage.service';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { ProductPackage } from '../../entity/product-package';
import { ProductClass } from '../../entity/product-class';
import { Product } from '../../entity/product';
import { Package } from '../../entity/package';
import { Sample } from '../../entity/sample';
import { Order } from '../../entity/order';
import { ResultDu } from '../../entity/result-du';
import { ThirdParty } from '../../entity/third-party';
import { RequestThirdParty } from '../../entity/request-third-party';
import { AlertService } from '../../shared/alert/alert.service';
import { AdditionalInformationService } from '../../shared/analysis/additional-information/additional-information.service';
import { ProducerAutocompleteSearchResult } from '../../shared/producers/producer-autocomplete-search-result';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'order',
  templateUrl: './fast-order.component.html'
})
export class FastOrderComponent {

  currentForm: NgForm;
  private currentFormValid: boolean;
  @ViewChild('step3Form') step3Form: NgForm;
  @ViewChild('step4Form') step4Form: NgForm;

  private job: string;
  private searchingCode: boolean;
  private code: string;
  private analysisCode: ProductPackage;
  private selectedProductPackages: ProductPackage[];
  private displayWizard: boolean;
  public search: string;
  private producers: ThirdParty[];
  private packages: Package[];
  private selectedProductClass: ProductClass;
  private selectedProduct: Product;
  private selectedPackages: Package[];
  private samples: Sample[];
  private samplesPackages: any[]
  private num_samples: number;
  private step: number;
  private changingOwner: boolean;
  private owner: ThirdParty;
  private frequencyNum: number;
  private frequencyPeriod: string;
  private recipientsList: ThirdParty[];
  private selectedRecipients: ThirdParty[];
  private otherRecipients: string[];
  private reprise_ip: boolean;
  private sampleCollector: string;
  private orderCode: string;
  private packagesChanged: boolean = false;
  isChangingSampleInfoSupp = false;
  changingSampleInfoSuppIndex: number;
  changingSampleInfoSuppModel: {};
  orderNumber: string = null;
  private siretLabs: any;
  clientRequestStatusCode: string;
  private recipientsListLoaded: boolean = false;
  public currentUser: ThirdParty;
  public takingDate: any;
  requestInfoSupModel: {};
  additionalInformation: {}[];
  requestInfoSupModelCopy = {};
  private waitingClientRequestStatusCode: string = null;
  private datePickerOptions: IMyOptions = {
    dateFormat: 'dd/mm/yyyy',
    dayLabels: {su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam'},
    monthLabels: { 1: 'Janvier', 2: 'Fevrier', 3: 'Mars', 4: 'Avril', 5: 'Mai', 6: 'Juin', 7: 'Juillet', 8: 'Aout', 9: 'Septembre', 10: 'Octobre', 11: 'Novembre', 12: 'Decembre' },
    showTodayBtn: false,
    sunHighlight: false,
    alignSelectorRight: false
  };
    producersList: ThirdParty[];
    producersListSearch: string;
    private producersListSearchBackup: string;
    private producersListBackup: ThirdParty[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private additionalInformationService: AdditionalInformationService,
    private spinnerService: SpinnerService,
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    private alertService: AlertService) {
    this.producersList = [];
    this.producersListSearch = null;
    this.requestInfoSupModel = {};
    this.searchingCode = false;
    this.displayWizard = false;
    this.analysisCode = null;
    this.code = "";
    this.selectedProductPackages = new Array();
    this.packages = new Array();
    this.selectedPackages = new Array();
    this.samples = new Array();
    this.producers = new Array();
    this.samplesPackages = new Array();
    this.selectedRecipients = new Array();
    this.otherRecipients = new Array();
    this.num_samples = 1;
    this.orderNumber = this.route.snapshot.params['order_number'];
    this.route.params.subscribe(
      params =>{
          this.step = parseInt(params['step']);
      }
    );
    this.changingOwner = false;
    this.currentFormValid = true;
    this.sampleCollector = "opt1";
    this.orderCode = null;
    // let today = new Date;
    // this.takingDate = { date: { year: today.getFullYear(), month: today.getMonth()+1, day: today.getDate() } };
    this.takingDate = null;
    this.currentUser = this.authenticationService.getCurrentUser().thirdParty;
    this.owner = this.authenticationService.getCurrentUser().thirdParty;
    if (!this.recipientsListLoaded) {
      this.getRecipientList();
    }
  }

  ngOnInit():void {

    if(this.step == 1){
      this.clearAll();
    }
    this.loadAll();
    if (this.step == 3) {
      if (!this.requestInfoSupModelCopy) {
        this.saveRequestInfoSupModel();
      }
      this.assignAdditionalInformationToSamples();
    }
  }


  ngDoCheck(): void
  {
    // this.checkStep();
    if(this.step == 5){
      // this.recipientsList = this.route.snapshot.data['data'];
    }
    if(this.step == 4){

    }
    if(this.step == 3){
      this.updatePackagesOfSamples();
      this.packagesChanged = false;
      this.changeNumSample();
    }
    if(this.step == 2){
      this.additionalInformation = this.route.snapshot.data['data'];
    }
    if(this.step == 1){
      if(this.orderNumber != null && this.step == 1){
        this.waitingClientRequestStatusCode = this.route.snapshot.data['status'];
        this.siretLabs = this.route.snapshot.data['sirets'];
        this.parseOrder(this.route.snapshot.data['order']);

      }
    }
  }

  ngAfterViewChecked() {
    this.formChanged();
  }

  formChanged() {
    switch (this.step) {
      case 3 :
        this.currentForm = this.step3Form;
        break;
      case 4 :
        this.currentForm = this.step4Form;
        break;
    }
    if (this.currentForm) {
      this.currentForm.valueChanges.subscribe(data => this.onValueChanged(data));
    }
  }

  onValueChanged(data?: any): void {
    let valid = true;
    if (!this.currentForm) { return; }
    const form = this.currentForm.form;
    for (let field in form.controls) {
      const control = form.get(field);

      if (control && !control.valid) {
        valid = false;
        if(control.dirty){
        }
      }
    }
    this.currentFormValid = valid;
  }

  validationMessages = {
    'frequencyNum': {
      'required':      'frequencyNum is required.',
    },
    'frequencyPeriod': {
      'required': 'frequencyPeriod is required.'
    }
  };

  formErrors = {
    'frequencyNum': '',
    'frequencyPeriod': ''
  };

  public back(event: any): void
  {
    event.preventDefault();
    switch (this.step) {
      case 3 :
        // this.selectedProduct = null;
        this.packages = new Array();
        break;
      case 2 :
        //this.selectedProductClass = null;
        break;
    }
    this.prevStep();
  }

  public goToStep(event: any, step: number): void
  {
    event.preventDefault();
    if(step < this.step){
      this.updateStep(step);
    }
  }

  public next(event: any): void
  {
    event.preventDefault();
    this.nextStep();
  }

  private nextStep(): void
  {
    let step = this.step + 1 ;
    // skip complentary infos if dairy product order
    if(step == 2 && this.isDairyProductOrder()) {
        step = 3 ;
    }
    this.updateStep(step);
  }

  private prevStep(): void
  {
    if (this.step>1) {
      let step = this.step - 1 ;
        // skip complentary infos if dairy product order
        if(step == 2 && this.isDairyProductOrder()) {
            step = 1 ;
        }
      this.updateStep(step);
    }
  }

  private updateStep(step): void
  {
    this.displayWizard = step > 1;
    this.search = "";
    this.saveAll();
    let routeData = {};

    if(step == 3){
      routeData['productId'] = this.selectedProduct.id;
      this.selectPackagesFromCodes();
      routeData['analysisCode'] = this.selectedProductPackages;
      if (!this.requestInfoSupModelCopy) {
        this.saveRequestInfoSupModel();
      }
      this.assignAdditionalInformationToSamples();
    }
    localStorage.setItem('routeData', JSON.stringify(routeData));
    let routePrefix = this.orderNumber ? '/' + this.orderNumber : '';
    this.router.navigate(['fast-order/'+step+routePrefix]);
  }

  public displayPrev(): boolean
  {
    let display = false;
    switch (this.step) {
      case 2 :
        display = true;
        break;
      case 3 :
        display = !this.changingOwner && !this.isChangingSampleInfoSupp;
        break;
      case 4 :
        display = true;
        break;
      case 5 :
        display = true;
        break;
      default:
        display = false;
    }
    return display;
  }

  public displayNext(): boolean
  {
    let display = false;
    switch (this.step) {
      case 1 :
        display = this.selectedProductPackages.length>0;
        break;
      case 2 :
        display = true;
        break;
      case 3 :
        display = !this.changingOwner && !this.isChangingSampleInfoSupp;
        break;
      case 4 :
        display = true;
        break;
      default:
        display = false;
    }
    return display;
  }

  public stepIsValid(): boolean
  {
    let valid = false;
    switch (this.step) {
      case 1:
        valid = this.selectedProductPackages.length > 0;
      case 2 :
        valid = true;
        break;
      case 3 :
          valid = this.selectedProductPackages.length > 0 ;
        break;
      case 4 :
        valid = true;
        break;
      case 5:
        valid = true;
        break;
      default:
        valid = false;
    }
    return valid;
  }

  private validateEmail(email): boolean
  {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  private parseOrder(order: Order){
    if(order!=null && order.objectRef.id!=null){
      this.selectedProduct = this.findMostUsedProduct(order);
      // order.objectRef
      this.selectedProductClass = order.objectRef.productClass;
      this.selectedPackages = order.objectRef.packages;
      this.selectedRecipients = new Array();
      for (const requestThirdParty of order.objectRef.thirdParties) {
        // we add third party with role DEST and which are different from the owner of the order in the selected recipients
        if (requestThirdParty.role === 'DEST' && requestThirdParty.thirdParty.id !== order.thirdPartyDmd.id) {
          this.selectedRecipients.push(requestThirdParty.thirdParty);
        }
      }
      this.otherRecipients = new Array();//TODO
      this.samples = new Array();
      this.num_samples = order.objectRef.samples.length;
      this.takingDate = { date: { year: order.objectRef.takingDate.get('year'), month: order.objectRef.takingDate.get('month')+1, day: order.objectRef.takingDate.get('date') } };
      this.clientRequestStatusCode = order.objectRef.clientRequestStatus.code;
      this.samplesPackages = [];
      for (let i = 0; i < order.objectRef.samples.length; i++) {
        const sample = order.objectRef.samples[i];
        this.samples.push(sample);
        for (let resultDu of sample.resultsDu) {
          if  (!this.samplesPackages[i]) {
            this.samplesPackages[i] = [];
          }
          this.samplesPackages[i].push(resultDu.package);
        }
        if (i == 0) {
          this.owner = sample.owner;
        }
      }
      if (this.owner.identity == "INCONNU") {
        let ownerName = order.objectRef.externalReference;
        this.owner = new ThirdParty();
        this.owner.label = ownerName;
        this.owner.businessName = ownerName;
      }
      const sampleCollectorSiret = order.objectRef.samples[0].collect.siret;
      if (this.siretLabs.indexOf(sampleCollectorSiret) !== -1) {
        this.sampleCollector = 'lab';
      } else {
        this.sampleCollector = 'prod';
      }
      this.orderCode = order.number;
    }
  }

  private findMostUsedProduct(order: Order) {
    // initialize the products with a fake product code so that reduce still works (as we need at least 2 elements)
    let products = {
      'fakeProductCode': {
        'weight': -1
      }
    };
    for (let sample of order.objectRef.samples) {
      let product = sample.product;
      let productCode = product.code;
      // initialize the product weight if we didn't meet the product yet
      if (!products[productCode]) {
        products[productCode] = {
          'product': product,
          'weight': 0
        };
      }
      // increase the weight each time we have this product
      products[productCode].weight++;
    }
    // return the product with the maximum weight
    const mostUsedProductCode = Object.keys(products)
    .reduce(
      function(a, b){
        return products[a].weight > products[b].weight ? a : b;
      }
    );
    return products[mostUsedProductCode].product;
  }


  /********************/
  /*****  Step 1  *****/
  /********************/

  public searchProductPackage(code): void
  {
    this.code = code;
    this.searchingCode = true;
    this.analysisCode = null;
    this.reprise_ip = false;
    this.orderService.getAnalysisByCode(this.code)
    .then(
      function(analysisCode: ProductPackage){
        this.analysisCode = analysisCode;
        this.searchingCode = false;
        if (!this.analysisCode) {
          return;
        }
        if (this.canAddAnalysis()) {
          this.addAnalysis();
        } else {
          this.showAnalysisIncompatibleErrorMessage();
        }
      }.bind(this),
      function(){
        this.searchingCode = false;
      }.bind(this)
    );
  }

  private analysisProductIsCompatible(): boolean {
    if (this.selectedProduct !== null) {
      return this.selectedProduct.id === this.analysisCode.product.id;
    }

    return true;
  }

  public addAnalysis(): void {
    if (this.selectedProductPackages.length === 0) {
      this.selectedProductClass = this.analysisCode.product.productClass;
      this.selectProduct(this.analysisCode.product);
    }
    this.selectedProductPackages.push(this.analysisCode);
    //this.alertService.success('L\'analyse ' + this.analysisCode.code + ' a été ajoutée à votre commande');
    this.analysisCode = null;
    this.computeJob();
  }

  /**
   * Analysis can be added if:
   *   - the products are the same
   *   - the analysis has not been added yet
   */
  canAddAnalysis() {
    return this.analysisProductIsCompatible() && !this.isCodeAlreadySelected();
  }

  public removeAnalysis(analysisCode): void {
    analysisCode.removeFromArray(this.selectedProductPackages);
    if (this.selectedProductPackages.length === 0) {
      this.selectedProductClass = null;
      this.selectedProduct = null;
      // if we removed the last analysis and we have one waiting in error, we can try to add the latter as the error must be gone
      if (this.analysisCode && this.canAddAnalysis()) {
         this.addAnalysis();
      }
    }
    this.computeJob();
  }

  hideAnalysisAndErrorMessage(): void {
    this.analysisCode = null;
    this.alertService.hideLastMessage();
  }

  private computeJob() {
    this.job = null;
    for (const productPackage of this.selectedProductPackages) {
      if (!this.job) {
        // job becomes the job code we have in the first loop
        this.job = productPackage.job.code;
      } else if (productPackage.job.code !== this.job) {
        // Otherwise we're at least at loop2. If the current job is not the one we had in the first loop, we set it to DIV as it is a default value
        // We do this as we can have only one job for a sample
        this.job = 'DIV';
        break;
      }
    }
  }

  public selectProduct(product: Product): void
  {
    this.selectedProduct = product;
    for (let sample of this.samples) {
      sample.product = this.selectedProduct;
    }
  }

  public showAnalysisIncompatibleErrorMessage(): void
  {
    if (!this.analysisProductIsCompatible()) {
      this.alertService.error('Impossible de sélectionner le code d\'analyse ' + this.analysisCode.code + ' car le produit (' + this.analysisCode.product.label + ') est différent de celui des analyses ajoutées à votre commande (' + this.selectedProduct.label + ')');
    } else {
      this.alertService.error('L\'analyse ' + this.analysisCode.code + ' est déjà ajoutée à votre commande');
    }
  }

  isCodeAlreadySelected() {
    for (const productPackage of this.selectedProductPackages) {
      if (productPackage.code === this.analysisCode.code) {
        return true;
      }
    }

    return false;
  }

  /********************/
  /*****  Step 2  *****/
  /********************/

  public selectPackagesFromCodes(): void
  {
    this.selectedPackages = [];
    for (let selectedProductPackage of this.selectedProductPackages) {
      this.selectedPackages[this.selectedPackages.length] = selectedProductPackage.package;
    }
    for (let sample of this.samples) {
      sample = this.setSampleResultsDu(sample, this.selectedPackages);
    }
  }

  /********************/
  /*****  Step 3  *****/
  /********************/

  /**
   * Put InfoSupp in all the samples of the model
   */
  private assignAdditionalInformationToSamples(): void {
    const requestInfoSupModelChanged = JSON.stringify(this.requestInfoSupModel) !== JSON.stringify(this.requestInfoSupModelCopy);
    for (const sample of this.samples) {
      if (requestInfoSupModelChanged || !sample['infoSupp']) {
          this.assignAdditionalInformationToSample(sample, this.requestInfoSupModel);
        }
    }
    if (requestInfoSupModelChanged) {
      this.saveRequestInfoSupModel();
    }
  }

  private saveRequestInfoSupModel() {
    this.requestInfoSupModelCopy = JSON.parse(JSON.stringify(this.requestInfoSupModel));
  }

  /**
   * Put InfoSupp in the given sample based on the provided infoSupp model
   */
  private assignAdditionalInformationToSample(sample: any, infoSuppModel: any): any {
    const infoSupp = {};
    for (const key of Object.keys(infoSuppModel)) {
      infoSupp[key] = {
        'code': infoSuppModel[key].code,
        'value': infoSuppModel[key].value,
        'type': infoSuppModel[key].type,
       };
    }
    sample['infoSupp'] = infoSupp;
  }



  /********************/
  /*****  Step 4  *****/
  /********************/

  /**
   * Delete the packages of samples when they are in the sample but not in the selected packages
   * Add the packages to samples when they are in the selected packages and not in the samples
   */
  updatePackagesOfSamples() {
    if (!this.packagesChanged) return;
    for (let sample of this.samples) {
      if (sample.product.code !== this.selectedProduct.code) {
        continue;
      }
      sample = this.setSampleResultsDu(sample, this.selectedPackages);
    }
  }

  public displayOwnerSelector(): boolean {
    let currentUserType = this.authenticationService.getCurrentUser().thirdParty.type;
    let codes = ['LAITE', 'SERVLAITE', 'TECHLAITE', 'GDS', 'SERVGDS'];
    return codes.indexOf(currentUserType.code) >= 0;
  }

  public getOwnerSelectorLabel(): string {
    if(this.owner.id!=this.currentUser.id){
        return this.owner.businessName + ' - ' + this.owner.identity;
    } else {
      return "...?";
    }
  }

  public setRepriseIp(event: any) {
      //alert(this.reprise_ip);
      if(this.reprise_ip)
        this.reprise_ip = false;
      else
        this.reprise_ip = true;
  }

  public resetOwner(event: any): void {
    event.stopPropagation();
    this.owner = this.currentUser;
    this.producersListBackup = [];
    this.producersList = [];
    this.producersListSearch = "";
    this.producersListSearchBackup = "";
    this.recipientsList = [];
    if (this.reprise_ip) {
      this.setSampleIdentifierByProducer();
    }
  }

  public addSample(event: any)
  {
    event.preventDefault();
    this.num_samples++;
    this.changeNumSample();
  }

  public removeSample(event: any)
  {
    event.preventDefault();
    this.num_samples--;
    this.changeNumSample();
  }

  public changeNumSample()
  {
    if(this.num_samples<1){
      this.num_samples = 1;
    }
    if(this.reprise_ip){
      this.num_samples = 1;
    }
    if (this.num_samples>this.samples.length) {
      this.addSamples(this.num_samples-this.samples.length);
    } else {
      this.removeSamples(this.samples.length-this.num_samples);
    }

  }

  private addSamples(num): void
  {
    if(this.reprise_ip){
      num = 1;
    }
    for (let i=0; i<num; i++) {
      let sample  = new Sample();
      sample.product = this.selectedProduct;
      this.samplesPackages[this.samples.length] = new Array();
      //obligé de faire une copie à la main de tous les forfaits sinon JS utilise la référence vers selectedPackage pour tous les échantillons
      for(let selectedPackage of this.selectedPackages) {
        this.samplesPackages[this.samples.length].push(selectedPackage);
      }
      sample = this.setSampleResultsDu(sample, this.samplesPackages[this.samples.length]);
      this.assignAdditionalInformationToSample(sample, this.requestInfoSupModel);
      this.samples[this.samples.length] = sample;
    }
  }

  private setSampleResultsDu(sample: Sample, packages: Package[]){
    sample.resultsDu = new Array();
    for (let i=0; i<packages.length; i++) {
      for (let j=0; j<packages[i].dus.length; j++) {
        let result = new ResultDu();
        result.du = packages[i].dus[j];
        result.package = packages[i];
        sample.resultsDu[sample.resultsDu.length] = result;
      }
    }
    return sample;
  }

  private removeSamples(num): void
  {
    for (let i=0; i<num; i++) {
      this.samples.splice(this.samples.length-i-1, 1);
      this.samplesPackages.splice(this.samplesPackages.length-i-1, 1);
    }
  }

  public deleteSample($event, i): void
  {
    this.samples.splice(i, 1);
    this.samplesPackages.splice(i, 1);
    this.num_samples--;
  }

  public changeOwner(): void {
    this.changingOwner = true;
  }

  changeSampleInfoSupp(sampleIndex: number): void {
    this.spinnerService.start('Chargement');
    this.additionalInformationService.getAdditionalInformation(this.selectedProductClass.code)
    .finally(() => {
      this.spinnerService.stop();
      this.isChangingSampleInfoSupp = true;
    })
    .subscribe(data => {
      this.additionalInformation = data;
      this.changingSampleInfoSuppIndex = sampleIndex;
      this.changingSampleInfoSuppModel = JSON.parse(JSON.stringify(this.samples[sampleIndex]['infoSupp']));
    });
  }

  cancelChangeSampleInfoSupp(): void {
    this.isChangingSampleInfoSupp = false;
  }

  validateChangeSampleInfoSupp(): void {
    this.samples[this.changingSampleInfoSuppIndex]['infoSupp'] = this.changingSampleInfoSuppModel;
    this.isChangingSampleInfoSupp = false;
  }

    /**
     * Select the producer
     * @param {ProducerAutocompleteSearchResult} data
     */
  selectProducer(data: ProducerAutocompleteSearchResult) {
      if (data.selectedProducer) {
          this.producersList = data.fetchedProducers;
          this.producersListSearch = data.search;
          this.selectOwner(data.selectedProducer);
      }
  }

  /**
   * Allow to be aware of any new producer research even though the user didn't select a producer
   * @param {ProducerAutocompleteSearchResult} data
   */
  handleNewSearchProducerAutocomplete(data: ProducerAutocompleteSearchResult) {
    const producersList = data.fetchedProducers;
    const search = data.search;
    if (!this.producersListSearchBackup) {
        this.setProducerBackupData(this.producersListSearch, this.producersList);
    }
    this.producersListSearch = search;
    this.producersList = producersList;
  }

  /**
   * Create a producer from the search input value, not from the list of producers
   */
  selectSearchAsOwner() {
    const producer = new ThirdParty();
    producer.label = this.producersListSearch;
    producer.businessName = this.producersListSearch;
    this.selectOwner(producer);
  }

  /**
   * Helper func to assign the owner
   * @param {ThirdParty} producer
   */
  private selectOwner(producer: ThirdParty) {
      this.setProducerBackupData(this.producersListSearch, this.producersList);
      this.owner = producer;
      this.recipientsList.shift();
      this.recipientsList.unshift(this.owner);
      this.changingOwner = false;
      if (this.reprise_ip){
          this.setSampleIdentifierByProducer();
      }
  }

  private setProducerBackupData(search: string, producersList: ThirdParty[]) {
    this.producersListSearchBackup = JSON.parse(JSON.stringify(search));
    this.producersListBackup = JSON.parse(JSON.stringify(producersList));
  }

    cancelProducerSelection() {
        this.changingOwner = false;
        this.producersListSearch = JSON.parse(JSON.stringify(this.producersListSearchBackup));
        this.producersList = JSON.parse(JSON.stringify(this.producersListBackup));
    }

  public producerBlink(): boolean
  {
    return this.reprise_ip && this.owner.id==this.currentUser.id && this.displayOwnerSelector();
  }

  public toggleRepriseIP(event): void
  {
    if(event.target.checked){
      this.setSampleIdentifierByProducer();
    } else {
      for (let index in this.samples) {
        this.samples[index].clientIdentifier = "";
      }
    }
  }

  private setSampleIdentifierByProducer(): void
  {
    if(this.owner.id != this.currentUser.id){
      for (let index in this.samples) {
        let clientIdentifier = null;
        if(this.owner.id == null){
          clientIdentifier = this.owner.label;
        } else {
          clientIdentifier = this.owner.identity;
        }
        this.samples[index].clientIdentifier = clientIdentifier;
      }
    } else {
      for (let index in this.samples) {
        this.samples[index].clientIdentifier = "";
      }
    }
  }

  /********************/
  /*****  Step 5  *****/
  /********************/

  public onTakingDateChanged(date: IMyDateModel): void {
    for (let i=0; i<this.samples.length; i++) {
      //this.samples[i].takingDate = moment(date['epoc']*1000);
    }
  }

  private getRecipientList(): void
  {
    let thirdPartyId = this.authenticationService.getCurrentUser().thirdParty.id;
    this.orderService.getRecipientsList(thirdPartyId)
    .then(
      function(recipients: ThirdParty[]){
        this.recipientsList = new Array();
        for (let recipient of recipients) {
          this.recipientsList.push(recipient);
        }
        this.recipientsListLoaded = true;
      }.bind(this),
      function(){
      }.bind(this)
    );
  }

  public addRecipient(event: any): void
  {
    event.preventDefault();
    this.otherRecipients.push("");
  }

  public selectRecipient(recipient: ThirdParty, event: any): void
  {
    if (event.target.checked) {
      this.selectedRecipients.push(recipient);
    } else {
      recipient.removeFromArray(this.selectedRecipients);
    }
  }

  public deleteOtherRecipient(event: any, index: number): void
  {
    event.preventDefault();
    this.otherRecipients.splice(index, 1);
  }

  customTrackBy(index: number, obj: any): any {
    return index;
  }

  /********************/
  /*****  Step 6  *****/
  /********************/

  public confirmOrder(event: any): void
  {
    event.preventDefault();
    this.placeOrder();
  }

  public updateOrder(event: any): void
  {
    event.preventDefault();
    this.spinnerService.start('Mise à jour de la commande');
    let data = new Object();
    data['repriseIp'] = this.reprise_ip;
    data['infoSupp'] = this.requestInfoSupModel;
    data['job'] = this.job;
    data['samples'] = this.samples;
    data['frequencyNum'] = this.frequencyNum;
    data['frequencyPeriod'] = this.frequencyNum;
    data['sampleCollector'] = this.sampleCollector;
    data['selectedRecipients'] = this.selectedRecipients;
    data['otherRecipients'] = this.otherRecipients;
    data['productClass'] = this.selectedProductClass;
    data['owner'] = this.owner;
    data['orderCode'] = this.orderNumber;
    data['takingDate'] = this.takingDate;
    this.orderService.updateOrder(data).then(
      function(code: any){
        this.orderCode = code;
        this.nextStep();
        this.clearAll();
        this.spinnerService.stop();
      }.bind(this),
      function(){
        this.spinnerService.stop();
      }.bind(this)
    );
  }

  private placeOrder(): void
  {
    this.spinnerService.start("Envoi de la commande");
    let data = new Object();
    data['infoSupp'] = this.requestInfoSupModel;
    data['job'] = this.job;
    data['repriseIp'] = this.reprise_ip;
    data['samples'] = this.samples;
    data['frequencyNum'] = this.frequencyNum;
    data['frequencyPeriod'] = this.frequencyNum;
    data['sampleCollector'] = this.sampleCollector;
    data['selectedRecipients'] = this.selectedRecipients;
    data['otherRecipients'] = this.otherRecipients;
    data['productClass'] = this.selectedProductClass;
    data['owner'] = this.owner;
    data['takingDate'] = this.takingDate;
    this.orderService.placeOrder(data).then(
      function(code: any){
        this.orderCode = code;
        this.nextStep();
        this.clearAll();
        this.spinnerService.stop();
      }.bind(this),
      function(){
        this.spinnerService.stop();
      }.bind(this)
    );
  }

  /*********************/
  /*****  Storage  *****/
  /*********************/

  public saveAll(): void
  {
    let directory = "mylab_order";
    this.localStorageService.save(directory, "selectedProductClass", this.selectedProductClass);
    this.localStorageService.save(directory, "selectedProduct", this.selectedProduct);
    this.localStorageService.save(directory, "selectedPackages", this.selectedPackages);
    this.localStorageService.save(directory, "samples", this.samples);
    this.localStorageService.save(directory, "owner", this.owner);
    this.localStorageService.save(directory, "selectedRecipients", this.selectedRecipients);
    this.localStorageService.save(directory, "reprise_ip", this.reprise_ip);
    this.localStorageService.save(directory, "otherRecipients", this.otherRecipients);
    this.localStorageService.save(directory, "num_samples", this.num_samples);
    this.localStorageService.save(directory, "sampleCollector", this.sampleCollector);
    this.localStorageService.save(directory, "takingDate", this.takingDate);
    this.localStorageService.save(directory, "sampleCollectordisplayWizard", this.displayWizard);
    this.localStorageService.save(directory, "selectedProductPackages", this.selectedProductPackages);
    this.localStorageService.save(directory, "job", this.job);
    this.localStorageService.save(directory, 'requestInfoSupModel', this.requestInfoSupModel);
    this.localStorageService.save(directory, 'requestInfoSupModelCopy', this.requestInfoSupModelCopy);
    this.localStorageService.save(directory, "producersList", this.producersList);
    this.localStorageService.save(directory, "producersListSearch", this.producersListSearch);
  }

  public loadAll(): void
  {
    let directory = "mylab_order";
    let selectedProductClass = this.localStorageService.get(directory, "selectedProductClass", "ProductClass");
    if(selectedProductClass){
      this.selectedProductClass = selectedProductClass;
    }
    let selectedProduct = this.localStorageService.get(directory, "selectedProduct", "Product");
    if(selectedProduct){
      this.selectedProduct = selectedProduct;
    }
    let selectedPackages = this.localStorageService.get(directory, "selectedPackages", "Package");
    if(selectedPackages){
      this.selectedPackages = selectedPackages;
    }
    let samples = this.localStorageService.get(directory, "samples", "Sample");
    if(samples){
      this.samples = samples;
    }
    let owner = this.localStorageService.get(directory, "owner", "ThirdParty");
    if(owner){
      this.owner = owner;
    }
    let selectedRecipients = this.localStorageService.get(directory, "selectedRecipients", "ThirdParty");
    if(selectedRecipients){
      this.selectedRecipients = selectedRecipients;
    }
    let reprise_ip = this.localStorageService.get(directory, "reprise_ip", null);
    if(reprise_ip){
      this.reprise_ip = reprise_ip;
    }
    let otherRecipients = this.localStorageService.get(directory, "otherRecipients", null);
    if(otherRecipients){
      this.otherRecipients = otherRecipients;
    }
    let num_samples = this.localStorageService.get(directory, "num_samples", null);
    if(num_samples){
      this.num_samples = num_samples;
    }
    let sampleCollector = this.localStorageService.get(directory, "sampleCollector", null);
    if(sampleCollector){
      this.sampleCollector = sampleCollector;
    }
    let takingDate = this.localStorageService.get(directory, "takingDate", null);
    if(takingDate){
      this.takingDate = takingDate;
    }
    let displayWizard = this.localStorageService.get(directory, "displayWizard", null);
    if(displayWizard){
      this.displayWizard = displayWizard;
    }
    let selectedProductPackages = this.localStorageService.get(directory, "selectedProductPackages", null);
    if(selectedProductPackages){
      this.selectedProductPackages = selectedProductPackages;
    }
    const job = this.localStorageService.get(directory, 'job', null);
    if (job) {
      this.job = job;
    }
    const requestInfoSupModel = this.localStorageService.get(directory, 'requestInfoSupModel', null);
    if (requestInfoSupModel) {
      this.requestInfoSupModel = requestInfoSupModel;
    }

    const requestInfoSupModelCopy = this.localStorageService.get(directory, 'requestInfoSupModelCopy', null);
    if (requestInfoSupModelCopy) {
      this.requestInfoSupModelCopy = requestInfoSupModelCopy;
    }

    const producersList = this.localStorageService.get(directory, "producersList", "ThirdParty");
    if (producersList){
        this.producersList = producersList;
    }
    const producersListSearch = this.localStorageService.get(directory, "producersListSearch", null);
    if (producersListSearch){
        this.producersListSearch = producersListSearch;
    }

    this.setProducerBackupData(this.producersListSearch, this.producersList);
  }

    public isDairyProductOrder() {

        if (this.selectedProductClass.code == 'PRODUITS LAITIERS') {
            return true;
        } else {
            return false;
        }
    }

    public downloadOrderForm(orderNumber): void {
        this.spinnerService.start('Chargement du bon de commande');
        this.orderService.downloadOrderForm(orderNumber).finally(() => {
        })
            .subscribe((doc: Blob) => {
                FileSaver.saveAs(doc, orderNumber + '.pdf');
                this.spinnerService.stop();
            })
        ;
  }
  
  public clearAll(): void
  {
    this.localStorageService.clear('mylab_order', null);

    this.selectedProductClass = null;
    this.selectedProduct = null;
    this.selectedPackages = new Array();
    this.samples = new Array();
    this.owner = this.authenticationService.getCurrentUser().thirdParty;
    this.requestInfoSupModel = {};
    this.requestInfoSupModelCopy = {};
    this.selectedRecipients = new Array();
    this.reprise_ip =false;
    this.otherRecipients = new Array();
    this.num_samples = 1;
    this.producersList = [];
    this.producersListSearch = "";
    this.sampleCollector = "opt1";
    this.takingDate = null;
    this.displayWizard = false;
    this.selectedProductPackages = new Array();
    this.job = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/order/fast-process/fast-order.component.ts